<div class="container-fluid">
  <form [formGroup]="formGroup">
    <div class="row mt-2">
      <!-- Name -->
      <div class="col-12 col-md-6 col-lg-6">
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input
            matInput
            formControlName="nameCtrl"
            aria-label="name"
            [disabled]="isDisabled"
            (change)="
              documentType!.name = nameCtrl?.value;
              changed.emit(documentType);
              setFormDirty()
            "
          />
          <mat-error *ngIf="nameCtrl?.invalid">
            {{ getErrorMsg(nameCtrl) }}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Description -->
      <div class="col-12 col-md-6 col-lg-6">
        <mat-form-field>
          <mat-label>Description</mat-label>
          <input
            matInput
            formControlName="descriptionCtrl"
            aria-label="description"
            [disabled]="isDisabled"
            (change)="
              documentType!.description = descriptionCtrl?.value;
              changed.emit(documentType);
              setFormDirty()
            "
          />
          <mat-error *ngIf="descriptionCtrl?.invalid">
            {{ getErrorMsg(descriptionCtrl) }}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Code -->
      <div class="col-12 col-md-6 col-lg-6">
        <mat-form-field>
          <mat-label>Code</mat-label>
          <input
            matInput
            formControlName="codeCtrl"
            maxlength="10"
            aria-label="code"
            [disabled]="isDisabled"
            (change)="
              documentType!.code = codeCtrl?.value;
              changed.emit(documentType);
              setFormDirty()
            "
          />
          <mat-error *ngIf="codeCtrl?.invalid">
            {{ getErrorMsg(codeCtrl) }}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Category -->
      <div class="col-12 col-md-6 col-lg-6">
        <mat-form-field>
          <mat-label>Category</mat-label>
          <mat-select
            formControlName="categoryCtrl"
            [compareWith]="compareById"
            (selectionChange)="categoryChanged($event)"
          >
            <mat-option
              *ngFor="let category of documentCategoryList"
              [value]="category"
            >
              {{ category.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="categoryCtrl?.invalid">
            Category is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>

  <!-- Show extra options only if category is Checklist -->
  <div
    class="row"
    *ngIf="categoryCtrl?.value?.id === documentCategory.Checklist"
  >
    <div class="col-12 col-md-6">
      <fieldset class="field-group d-flex justify-content-around">
        <legend>Menu Options</legend>

        <mat-slide-toggle
          [disabled]="!hasPrivilege(privilegeEnum.ModifyDocumentType)"
          [checked]="!!menuItemChk"
          (change)="
            menuItemChk
              ? removeMenu(menuType.Checklist)
              : createMenu(menuType.Checklist)
          "
        >
          Show in Checklists
        </mat-slide-toggle>

        <mat-slide-toggle
          [disabled]="!hasPrivilege(privilegeEnum.ModifyDocumentType)"
          [checked]="!!menuItemBld"
          (change)="
            menuItemBld
              ? removeMenu(menuType.Builder)
              : createMenu(menuType.Builder)
          "
        >
          Show in Template Builders
        </mat-slide-toggle>
      </fieldset>
    </div>
  </div>
</div>
